
import React from 'react';
import { Navbar } from '../../Navbar';
import { QurbaniForm } from '../../QurbaniForm';

export function AddNew() {
  return (
    <>
    <Navbar/>
      <div className="">
        <div className="p-2">
          <QurbaniForm />
        </div>
      </div>
    </>
  );
}